import { Button, Stack, Typography } from '@mui/material';
import { createRootRoute, Link } from '@tanstack/react-router';
import { trackAnalytics } from '@puffin/app-frame-api';
import { AppShell } from '../../components/AppShell';

const NotFoundPage = () => (
  <Stack spacing={2} sx={{ alignItems: 'flex-start' }}>
    <Typography component="h1" variant="h4" sx={{ fontWeight: 700 }}>
      Page not found
    </Typography>
    <Typography color="text.secondary">The page you requested does not exist.</Typography>
    <Button component={Link} to="/" variant="contained" onClick={() => trackAnalytics('NOT_FOUND_HOME_SELECTED', {})}>
      Back to Meisterplan Dev Platform
    </Button>
  </Stack>
);

export const rootRoute = createRootRoute({ component: AppShell, notFoundComponent: NotFoundPage });
